var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C13.9 6 17 5.1 17 4C17 2.9 13.9 2 10 2C6.1 2 3 2.9 3 4C3 5.1 6.1 6 10 6ZM10 15C6.1 15 3 14.1 3 13V16C3 17.1 6.1 18 10 18C13.9 18 17 17.1 17 16V13C17 14.1 13.9 15 10 15ZM10 11C6.1 11 3 10.1 3 9V12C3 13.1 6.1 14 10 14C13.9 14 17 13.1 17 12V9C17 10.1 13.9 11 10 11ZM10 7C6.1 7 3 6.1 3 5V8C3 9.1 6.1 10 10 10C13.9 10 17 9.1 17 8V5C17 6.1 13.9 7 10 7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabase);
export default __webpack_public_path__ + "static/media/icon__database.b072fce54dbfaf06f9f2cbbaa474d334.svg";
export { ForwardRef as ReactComponent };